let inject = ['$scope', '$uibModalInstance','modalOptions', '$timeout'];

class ProductCommentModalController {
  constructor ($scope,$uibModalInstance,modalOptions, $timeout) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$uibModalInstance = $uibModalInstance;
    this.item = Object.assign({}, modalOptions);
    this.comment = this.item.comment;
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close(this.comment);
  }
}

ProductCommentModalController.$inject = inject;

export default ProductCommentModalController;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/cart/product-comment-modal/product-comment-modal.controller.js
 **/